module.exports = __webpack_public_path__ + "assets/images/home/footer-bg@2x.5aedb74a90aa02128c9894dd860044a9.webp";